<header class="sz-topbar">
  <button *ngIf="narrow" type="button" class="sz-topbar-hamburger" (click)="shell.openDrawer()" title="Menü">
    <span class="sz-icon sz-icon-24">menu</span>
  </button>

  <a class="sz-topbar-mlogo" *ngIf="narrow && isHome" [routerLink]="['/']"><img src="assets/images/szirom/logo-full-dark.png" alt="Pharmaroad" /></a>

  <div class="sz-topbar-titles" [class.sz-topbar-titles-hidden]="narrow && isHome">
    <div class="sz-topbar-crumb">
      <span>{{ crumbRoot }}</span>
      <span class="sz-icon sz-icon-16 sz-topbar-crumb-sep">chevron_right</span>
      <span class="sz-topbar-crumb-current">{{ crumb || pageTitle }}</span>
    </div>
    <div class="sz-topbar-title">{{ pageTitle }}</div>
  </div>

  <div *ngIf="envLabel" class="sz-topbar-env">{{ envLabel }}</div>

  <label class="sz-topbar-search" *ngIf="!narrow && canSearch">
    <span class="sz-icon">search</span>
    <input
      #searchInput
      type="text"
      [(ngModel)]="searchTerm"
      (keydown.enter)="submitSearch()"
      placeholder="Számlaszám, termék…"
      autocomplete="off"
    />
    <span class="sz-topbar-kbd">Ctrl K</span>
  </label>

  <!-- súgó az aktuális oldalhoz; patikai szerepkörnél menü: Súgó / Hiba bejelentése -->
  <div class="sz-topbar-notif sz-topbar-helpwrap" *ngIf="hasHelp" (click)="$event.stopPropagation()">
    <button type="button" class="sz-topbar-bell sz-topbar-help" [class.sz-topbar-bell-on]="helpOpen" (click)="onHelpClick()" [title]="canReportIssue ? 'Súgó és hibajelzés' : 'Súgó ehhez az oldalhoz'" aria-label="Súgó" [attr.aria-haspopup]="canReportIssue ? 'true' : null" [attr.aria-expanded]="canReportIssue ? helpOpen : null">
      <span class="sz-icon sz-icon-24">help</span>
    </button>
    <div class="sz-notif-panel sz-help-panel sz-card" *ngIf="helpOpen">
      <button type="button" class="sz-help-item" (click)="openHelp()">
        <span class="sz-notif-icon"><span class="sz-icon sz-icon-20">menu_book</span></span>
        <span class="sz-notif-text"><span class="sz-notif-item-title">Súgó ehhez az oldalhoz</span><span class="sz-notif-item-meta">Használati útmutató a megnyitott fejezetnél</span></span>
      </button>
      <button type="button" class="sz-help-item" (click)="reportIssue()">
        <span class="sz-notif-icon"><span class="sz-icon sz-icon-20">bug_report</span></span>
        <span class="sz-notif-text"><span class="sz-notif-item-title">Hiba bejelentése</span><span class="sz-notif-item-meta">A portál vagy a Szirom Pont app hibája, az aktuális oldallal</span></span>
      </button>
    </div>
  </div>

  <!-- értesítések: harang + lenyíló panel -->
  <div class="sz-topbar-notif" (click)="$event.stopPropagation()">
    <button type="button" class="sz-topbar-bell" [class.sz-topbar-bell-on]="notifOpen" (click)="toggleNotifications()" title="Értesítések" aria-haspopup="true" [attr.aria-expanded]="notifOpen">
      <span class="sz-icon sz-icon-24" [class.sz-icon-fill]="badge > 0">notifications</span>
      <span *ngIf="badge > 0" class="sz-topbar-badge">{{ badge > 99 ? '99+' : badge }}</span>
    </button>

    <div class="sz-notif-panel sz-card" *ngIf="notifOpen">
      <div class="sz-notif-head">
        <div class="sz-notif-title">Értesítések<span class="sz-notif-count" *ngIf="badge > 0">{{ badge }} új</span></div>
        <button type="button" class="sz-notif-link" *ngIf="badge > 0" (click)="markAllRead()">Mind olvasott</button>
      </div>
      <div class="sz-notif-list">
        <button
          type="button"
          class="sz-notif-item"
          *ngFor="let n of notifications; trackBy: trackNotif"
          [class.sz-notif-item-unread]="!n.readAt"
          (click)="openNotification(n)"
        >
          <span class="sz-notif-icon"><span class="sz-icon sz-icon-20">{{ iconOf(n.kind) }}</span></span>
          <span class="sz-notif-text">
            <span class="sz-notif-item-title">{{ n.title }}</span>
            <span class="sz-notif-item-body" *ngIf="n.body">{{ n.body }}</span>
            <span class="sz-notif-item-meta">{{ n.kindLabel }} · {{ ago(n.createdAt) }}</span>
          </span>
          <span class="sz-notif-dot" *ngIf="!n.readAt"></span>
        </button>
        <div class="sz-notif-empty" *ngIf="!notifications.length">
          <span class="sz-icon sz-icon-24">notifications_off</span>
          <span>Nincs értesítésed.</span>
        </div>
      </div>
      <div class="sz-notif-foot">
        <a class="sz-notif-link" [routerLink]="['/settings']" fragment="ertesitesek" (click)="notifOpen = false"><span class="sz-icon sz-icon-16">tune</span>Értesítési beállítások</a>
      </div>
    </div>
  </div>
</header>
